import { createStore, applyMiddleware, compose } from "redux";
import rootReducer from "./reducers/index";
import { thunk } from "redux-thunk"; // Change this line

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(rootReducer, composeEnhancers(applyMiddleware(thunk)));

export default store;
